import { selectBalancingBalloonContent } from "../balancingSelectors/selectBalancingBalloonContents";
import { utilNumber } from "../utils/utilNumber";
import { selectPlayerLevel } from "./selectPlayerLevelInfo";
export var selectBalloonInfo = function (state) {
    return state.balloonInfo;
};
export var selectBalloonContentInfo = function (state) {
    var balloonContentId = selectBalloonInfo(state).balloonContentId;
    if (balloonContentId) {
        var playerLevel_1 = selectPlayerLevel(state);
        var balloonContent = selectBalancingBalloonContent(balloonContentId);
        var isBalloonContentEnabled = balloonContent &&
            balloonContent.unlockRequirement &&
            balloonContent.unlockRequirement.some(function (value) { return value.playerLevel <= playerLevel_1; });
        if (isBalloonContentEnabled) {
            return balloonContent;
        }
    }
    return undefined;
};
export var selectBalloonContentLevelType = function (state, balloonContent) {
    var balloonLevel = selectBalloonInfo(state).balloonLevel;
    if (balloonLevel && balloonContent && balloonContent.level) {
        return balloonContent.level[utilNumber.clamp(balloonLevel - 1, 0, balloonContent.level.length - 1)];
    }
    return undefined;
};
export var selectBalloonRemainingTime = function (state) {
    return selectBalloonInfo(state).remainingTime;
};
export var selectBalloonRemainingTimeWithBuff = function (state) {
    return selectBalloonInfo(state).balloonOfferBufferTime;
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectBalloonInfo.ts
// module id = 291
// module chunks = 3